import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SupplierService} from '../../shared/api/resources/supplier/supplier.service';
import {AgentService} from '../../shared/api/resources/agent/agent.service';
import {Partner} from '../../shared/api/model/partner';
import {Product} from '../../shared/api/model/product';
import {CommunityService} from '../../shared/api/resources/community/community.service';
import {ToasterService} from '../../shared/global/toaster.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ReportSupplierComponent} from '../../shared/atoms/report-supplier/report-supplier.component';
import {NotificationDetailsComponent} from '../../shared/atoms/notification-details/notification-details.component';
import { NotificationsService } from '../../shared/api/resources/notifications/notifications.service';

@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrls: ['./supplier.component.scss']
})
export class SupplierComponent implements OnInit {
  supplierId!: number;
  supplier: any;
  agentId!: number;
  products: any[] = [];
  loadingSupplier = true;
  sendingRequest = false;
  disconnectRequest = false;
  notifications: any[] = [];

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _supplierService: SupplierService,
    private _agentService: AgentService,
    private _communityService: CommunityService,
    private _toasterService: ToasterService,
    private _modalService: NgbModal,
    private _router: Router,
    private _notificationsService: NotificationsService
    ) { }

  ngOnInit() {
    this._activatedRoute.params.subscribe(async (params) => {
      this.supplierId = parseInt(params['id'], 10);
      await this.getSupplierData();
    });
    this._notificationsService.getNotificationsList().subscribe((notifications) => {
      this.notifications = notifications;
    });
  }

  getSupplierData(): Promise<Partner> {
    return new Promise<Partner>((resolve, reject) => {
      this.loadingSupplier = true;
      this._communityService.getSupplierByIdToAgent(this.supplierId).subscribe(
        (supplier) => {
          this.supplier = supplier;
          this.products = this.supplier.products;
          resolve(this.supplier);
        },
        undefined,
        () => {
          this.loadingSupplier = false;
          if (this.supplier === undefined) {
            reject();
          }
        }
      );
    });
  }

  sendRequest($event?: any) {
    if ($event) {
      $event.stopPropagation();
    }
    this.sendingRequest = true;
    this._communityService.sendConnectRequestToSupplier(this.supplier.id).subscribe(
      () => this._toasterService.showInfo('Request sent to ' + this.supplier.brand),
      undefined,
      () =>  this.sendingRequest = false
    );
  }

  disconnect() {
    this.disconnectRequest = true;
    this._communityService.removeSupplierProtocol(this.supplier.id).subscribe(
      () => this._toasterService.showInfo('Disconnected from ' + this.supplier.brand),
      undefined,
      () =>  this.disconnectRequest = false
    );
  }

  async goToProductEvents(id: number) {
    await this._router.navigateByUrl('/partner/' + this.supplier.id + '/product-events/' + id);
  }

  report() {
    const modalRef = this._modalService.open(ReportSupplierComponent, {size: 'lg'});
    modalRef.componentInstance.supplier = this.supplier;
  }

  openAgreementModal() {
    this._agentService.getAgentResume().subscribe(
      (resume: any) => {
        const suppliers = resume && (resume.suppliers || resume);
        if (!suppliers || !Array.isArray(suppliers)) {
          this._toasterService.showError('Suppliers resume unavailable.');
          return;
        }

        const supplierEntry = suppliers.find((s: any) => s.id === this.supplierId || s.supplierId === this.supplierId);
        if (!supplierEntry) {
          this._toasterService.showError('Supplier not found in resume.');
          return;
        }

        const agentConnectionId = supplierEntry.agentConnectionId;
        if (!agentConnectionId) {
          this._toasterService.showError('agentConnectionId not available for this supplier.');
          return;
        }

        this._agentService.getAgentCommissions(this.supplierId, agentConnectionId).subscribe(
          res => {
            const modalRef = this._modalService.open(NotificationDetailsComponent);

            const protocolMessage: any = {
              SupplierBrandName: this.supplier && (this.supplier.brand || this.supplier.brandName) ? (this.supplier.brand || this.supplier.brandName) : 'Supplier',
              SupplierImageURL: this.supplier && (this.supplier.imageLogo || this.supplier.logo || this.supplier.image) ? (this.supplier.imageLogo || this.supplier.logo || this.supplier.image) : '',
              Products: (res.commissionRelations || []).map((cr: any) => ({
                ProductName: cr.productName || 'Product',
                ProductCommission: (cr.productAmountValue !== null && cr.productAmountValue !== undefined && cr.productAmountValue !== '')
                  ? `${cr.productAmountValue}%`
                  : ''
              }))
            };

            modalRef.componentInstance.notification = {
              type: 2,
              date: new Date().toISOString(),
              message: JSON.stringify(protocolMessage)
            };

            modalRef.componentInstance.commissions = res.commissionRelations || [];
            modalRef.componentInstance.showFooter = true;
            modalRef.componentInstance.modalType = 'agreement';
            modalRef.componentInstance.showHeader = false;
          },
          () => this._toasterService.showError('Error loading commissions')
        );
      },
      () => this._toasterService.showError('Failed to retrieve agent resume')
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/explore/supplier/supplier.component.ts